/* eslint-disable */
/* Pendo */
export function initPendo() {
    (function (apiKey) {
        (function (p, e, n, d, o) {
            let v;
            let w;
            let x;
            let y;
            let z;
            o = p[d] = p[d] || {};
            o._q = [];
            /**
             * Adding "showGuideById" invocations to the queued methods
             * To prevent calling a guide before pendo is fully initialized
             */
            v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'showGuideById'];
            for (w = 0, x = v.length; w < x; ++w) {
                (function (m) {
                    o[m] =
                        o[m] ||
                        function () {
                            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                        };
                })(v[w]);
            }
            y = e.createElement(n);
            y.async = !0;
            /**
             * Changing cdn.pendo.io to an internal domain where pendo snippet is hosted
             * in order for pendo to work correctly with adblockers
             */
            y.src = 'https://content.p-a.egnyte.com/agent/static/' + apiKey + '/pendo.js';
            z = e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
    })('92676276-3fac-4873-6e27-2abacf94eee3');
}
